import { render, staticRenderFns } from "./MeunItem.vue?vue&type=template&id=3ac3f98f&scoped=true"
import script from "./MeunItem.vue?vue&type=script&lang=js"
export * from "./MeunItem.vue?vue&type=script&lang=js"
import style0 from "./MeunItem.vue?vue&type=style&index=0&id=3ac3f98f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac3f98f",
  null
  
)

export default component.exports